import React from 'react'
import Card from '../components/card'
import FormGroup from '../components/form-group';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import moment from 'moment';
import GerarAtaService from '../app/service/gerarAtaService';
import ClipLoader from "react-spinners/ClipLoader";
import { mensagemErro} from '../components/toastr';
import {AuthContext} from '../main/provedorAutenticacao';
import CardGroup from '../components/card-group';
import ptBR from 'date-fns/locale/pt-BR';
import 'primeicons/primeicons.css';
import { Button } from 'primereact/button';

class ConsultaAta extends React.Component{

    state = {
        numeroProcesso: null,
        dataReferencia: null,
        loading:false,
        disabled:false,
        mensagem:'',
        mensagemData:''
    }
  
    constructor(){
        super();
        this.service = new GerarAtaService();
    }

    limpar = ()=> {
        this.setState({
            mensagem:'',
            numeroProcesso: ""
        });
    }

    validar(){
        let msgs = [];
        //alert(this.state.numeroProcesso.length);

        if (!this.state.numeroProcesso) {
            msgs.push('O campo número do processo é obrigatório.')
        } else if (this.state.numeroProcesso.length < 9 ){
           msgs.push('Informe o número do processo de 9 digitos.')
        }

        return msgs;
    }


    validarData(){
        let msgs = [];
        //alert(this.state.numeroProcesso.length);

        if (!this.state.dataReferencia) {
            msgs.push('O campo data é obrigatório.')
        }

        return msgs;
    }

    limparData = ()=> {
        this.setState({
            mensagemData:'',
            dataReferencia: ""

        });
    }

    consultarAtaPorProcesso = async () => {
        this.setState({loading: true,
            disabled:true})

        const dadosConsulta = {
             numeroProcesso: this.state.numeroProcesso
         }

        try{
            const response = await this.service.conultaAtaPorProcesso(dadosConsulta)
            this.setState({mensagem:response.data});
        }catch( erro){
            mensagemErro(erro.response.data)
        }finally{
            this.setState({loading: false,
                disabled:false})
        }
    }

    consultarPorProcesso = () => {
        
        this.setState({mensagem:''});
    
        const msgs = this.validar();
       // alert(msgs);
        const size = msgs.length;
     //   alert('msgs.length ', msgs.length > 0);
        if (msgs.length > 0){
            msgs.forEach( (msgs, index) =>{
                mensagemErro(msgs)
            } )
          // return false;
        } else{
            this.consultarAtaPorProcesso();
        }
 
      
    }


    consultarAtaPorData = async () => {
        this.setState({loading: true,
            disabled:true})

        const dadosConsulta = {
            dataReferencia: moment(this.state.dataReferencia).format('DD/MM/yyyy'),
         }

        try{
            const response = await this.service.conultaAtaPorData(dadosConsulta)
            this.setState({mensagemData:response.data});
        }catch( erro){
            mensagemErro(erro.response.data)
        }finally{
            this.setState({loading: false,
                disabled:false})
        }
    }

    consultarPorData = () => {
        
        this.setState({mensagemData:''});
    
        const msgs = this.validarData();
       // alert(msgs);
        const size = msgs.length;
     //   alert('msgs.length ', msgs.length > 0);
        if (msgs.length > 0){
            msgs.forEach( (msgs, index) =>{
                mensagemErro(msgs)
            } )
          // return false;
        } else{
            this.consultarAtaPorData();
        }
 
      
    }


     render(){

        return (
           <form>
            
           <Card title="Consultar Ata">
            <fieldset disabled ={this.state.disabled}>
             <div className="row">
               <div className="col-md-8 fildeset-form">                     
                    <div className="bs-component">
                        <br/>
                        <CardGroup title="Consulta Ata por Número de Processo:" > 
                            {/* <FormGroup label="Período da consulta: *"  htmlFor="inputNome">     */}
                            <FormGroup label="Número Processo: *"  htmlFor="inputNumero">

                                <div className="row col-md-12">
                                    <div className="col-md-3">
                                    <input type="text"
                                           id="inputNumero"
                                           className="form-control"
                                           name="processo"
                                           onChange={e => this.setState({numeroProcesso: e.target.value})}
                                           value={this.state.numeroProcesso} 
                                           />
                                
                                    </div>
                                    <div className="col-md-3">
                                        <button onClick={this.consultarPorProcesso} className="btn btn-success">
                                            <i className="pi pi-undo"> </i> 
                                        </button>
                                        <button onClick={this.limpar} type="button" className="btn btn-danger">
                                            <i className="pi pi-times"> </i> 
                                        </button>
                                    </div>
                                </div>
                                <br/>
                                <div className="row col-md-12" style={{color: "blue"}}>
                                     {this.state.mensagem}
                               </div>
                            </FormGroup>
          
                         </CardGroup>
                         <br/>
                         <ClipLoader loading={this.state.loading} size={150} />
                         <CardGroup title="Consulta Ata por Data de Geração:" > 
                            {/* <FormGroup label="Período da consulta: *"  htmlFor="inputNome">     */}
                            <FormGroup label="Data Geração *"  htmlFor="inputNumero">

                                <div className="row col-md-12">
                                    <div className="col-md-3">
                                            <DatePicker 
                                                selected={this.state.dataReferencia} 
                                                onChange={date => this.setState({dataReferencia: date})} 
                                                className="form-control"  
                                                id="iniDate"
                                                dateFormat="dd/MM/yyyy"
                                               // placeholderText = "Data Início"
                                                locale = {ptBR}
                                            />
                                    </div>
          
                                    <div className="col-md-3">
                                        <button onClick={this.consultarPorData} className="btn btn-success">
                                            <i className="pi pi-undo"> </i> 
                                        </button>
                                        <button onClick={this.limparData} type="button" className="btn btn-danger">
                                            <i className="pi pi-times"> </i> 
                                        </button>
                                    </div>
                                </div>
                                <br/>
                                <div className="row col-md-12" style={{color: "blue"}}>
                                     {this.state.mensagemData}
                               </div>
                            </FormGroup>
        
                         </CardGroup>
                        
                      </div>
                </div>
               </div> 
               </fieldset>
            </Card>

       
            </form> 
        )

    }
}

ConsultaAta.contextType = AuthContext;

export default ConsultaAta;

